import { isTreatmentEnabled } from '@vp/ctc-reader';

const isProAdvantageCustomer = () => {
  try {
    if (!window.location.href.includes('localhost')) {
      if (isTreatmentEnabled('proadvantage_basic_care') || isTreatmentEnabled('proadvantage_premium_care')) {
        console.info('Pro Advantage Customer detected');
        return true;
      }
    }
    return false;
    /* eslint-disable  @typescript-eslint/no-explicit-any */
  } catch (error: any) {
    console.error('Error occurred while checking Pro Advantage customer status:', error);
    return false;
  }
};

const loadProAdvantageScripts = (locale: string) => {
  const scriptURL = `https://d7pet6vgg99z9.cloudfront.net/JS-build/${locale}/ca-pro-adv-production-${locale}.js`;
  try {
    const script = document.createElement('script');
    script.src = scriptURL;
    script.onerror = () => console.error(`Failed to load Pro Advantage script from ${scriptURL}`);
    document.head.appendChild(script);
    console.info(`Loading Pro Advantage script from ${scriptURL}`);
  } catch (error) {
    console.error('Error loading Pro Advantage script:', error);
  }
};

export { isProAdvantageCustomer, loadProAdvantageScripts };
